import React from 'react';
import Axios from 'axios';
import { NotificationManager } from 'components/common/react-notifications';
import {
  defaultDirection,
  defaultLocale,
  defaultColor,
  localeOptions,
  themeColorStorageKey,
  themeRadiusStorageKey,
  UserRole,
} from 'constants/defaultValues';
import CryptoJS from 'crypto-js';
import { Badge } from 'reactstrap';
import { ActionStatusType } from 'redux/types';
import moment from 'jalali-moment';

export const mapOrder = (array, order, key) => {
  // eslint-disable-next-line func-names
  array.sort(function (a, b) {
    const A = a[key];
    const B = b[key];
    if (order.indexOf(`${A}`) > order.indexOf(`${B}`)) {
      return 1;
    }
    return -1;
  });
  return array;
};

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; // January is 0!

  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}.${mm}.${yyyy}`;
};

export const getCurrentTime = () => {
  const now = new Date();
  return `${now.getHours()}:${now.getMinutes()}`;
};

export const getDirection = () => {
  let direction = defaultDirection;

  try {
    if (localStorage.getItem('direction')) {
      const localValue = localStorage.getItem('direction');
      if (localValue === 'rtl' || localValue === 'ltr') {
        direction = localValue;
      }
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : getDirection -> error', error);
    direction = defaultDirection;
  }
  return {
    direction,
    isRtl: direction === 'rtl',
  };
};
export const setDirection = (localValue) => {
  let direction = 'ltr';
  if (localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue;
  }
  try {
    localStorage.setItem('direction', direction);
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setDirection -> error', error);
  }
};

export const getCurrentColor = () => {
  let currentColor = defaultColor;
  try {
    if (localStorage.getItem(themeColorStorageKey)) {
      currentColor = localStorage.getItem(themeColorStorageKey);
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : getCurrentColor -> error', error);
    currentColor = defaultColor;
  }
  return currentColor;
};

export const setCurrentColor = (color) => {
  try {
    localStorage.setItem(themeColorStorageKey, color);
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentColor -> error', error);
  }
};

export const getCurrentRadius = () => {
  let currentRadius = 'rounded';
  try {
    if (localStorage.getItem(themeRadiusStorageKey)) {
      currentRadius = localStorage.getItem(themeRadiusStorageKey);
    }
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : getCurrentRadius -> error',
      error
    );
    currentRadius = 'rounded';
  }
  return 'rounded'; // currentRadius;
};
export const setCurrentRadius = (radius) => {
  try {
    localStorage.setItem(themeRadiusStorageKey, radius);
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : setCurrentRadius -> error',
      error
    );
  }
};

export const getCurrentLanguage = () => {
  let language = defaultLocale;
  try {
    language =
      localStorage.getItem('currentLanguage') &&
      localeOptions.filter(
        (x) => x.id === localStorage.getItem('currentLanguage')
      ).length > 0
        ? localStorage.getItem('currentLanguage')
        : defaultLocale;
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : getCurrentLanguage -> error',
      error
    );
    language = defaultLocale;
  }
  return language;
};
export const setCurrentLanguage = (locale) => {
  try {
    localStorage.setItem('currentLanguage', locale);
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : setCurrentLanguage -> error',
      error
    );
  }
};

export function getIntFromLocalStringNumber(value) {
  if (!value) return 0;
  value = value.substring(0, 19);
  // eslint-disable-next-line no-useless-escape
  return Number(value.replace(/^\.|[^-?\d\.]|\.(?=.*\.)|^0+(?=\d)/g, ''));
}

// seprate number 123,456,789,000
export function getLocalNumber(value, useGrouping = true) {
  if (!value) return 0;
  return Number(value).toLocaleString('fa', { useGrouping });
}

export const getCurrentUser = () => {
  let user = null;
  try {
    user =
      localStorage.getItem('user') != null
        ? JSON.parse(localStorage.getItem('user'))
        : null;
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js  : getCurrentUser -> error', error);
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentUser -> error', error);
  }
};

export const just_persian = (str) => {
  console.log({ str });
  var p = /^[\u0600-\u06FF\s]+$/;
  if (!p.test(str)) {
    return false;
  }
  return true;
};

export const validateNation = (value) => {
  let error;
  if (!isValidIranianNationalCode(toEnglishDigits(value))) {
    error = `کد ملی صحیح نمی باشد`;
  }
  return error;
};

export const validateMobile = (value) => {
  let error;
  if (!isValidMobile(toEnglishDigits(value))) {
    error = `شماره موبایل صحیح نمی باشد`;
  }
  return error;
};
export const validateSelect = (value) => {
  let error;
  if (!value || value.length == 0) {
    error = `لطفا یک گزینه را انتخاب کنید`;
  }
  return error;
};

export const validateName = (value) => {
  let error;
  console.log({ value });
  if (!value) {
    error = `این فیلد الزامی می باشد`;
  } else if (value.length < 2) {
    error = 'باید بیشتر از 2 تا کاراکتر باشه';
  }
  return error;
};

export const validateNumber = (value, moreThan = undefined) => {
  let error;
  if (Number.isNaN(value)) {
    error = `این فیلد عددی الزامی می باشد`;
  } else if (parseInt(value) < 0) {
    error = 'مقدار باید بزرگتر مساوی 0 باشد';
  } else if (parseInt(value) > moreThan) {
    error = `مقدار باید کوچکتر مساوی با ${moreThan} باشد.`;
  }
  return error;
};

export const validateSheba = (value) => {
  let error;
  if (Number.isNaN(value)) {
    error = `این فیلد عددی الزامی می باشد`;
  } else if (value.length != 24) {
    error = 'شماره شبا ۲۴ رقم می باشد';
  }
  return error;
};
export const validateCardNumber = (value) => {
  let error;
  if (Number.isNaN(value)) {
    error = `این فیلد عددی الزامی می باشد`;
  } else if (value.length != 16) {
    error = 'شماره کارت ۱۶ رقم می باشد';
  }
  return error;
};

export const isNumeric = (str) => {
  if (typeof str != 'string') return false; // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ); // ...and ensure strings of whitespace fail
};

export const isValidMobile = (number) => {
  var regex = new RegExp('^09\\d{9}$');
  var result = regex.test(number);
  return result;
};

export const isValidIranianNationalCode = (input) => {
  if (!/^\d{10}$/.test(input)) return false;
  const check = +input[9];
  const sum =
    input
      .split('')
      .slice(0, 9)
      .reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
  return sum < 2 ? check === sum : check + sum === 11;
};

function generateRandomInteger(min, max) {
  return Math.floor(min + Math.random() * (max - min + 1));
}

export const generatorIranianNationalCode = () => {
  let input = generateRandomInteger(1111111111, 9999999999).toString();

  const check = +input[9];
  const sum =
    input
      .split('')
      .slice(0, 9)
      .reduce((acc, x, i) => {
        return acc + +x * (10 - i);
      }, 0) % 11;

  if (sum < 2) {
    input = input.slice(0, 9) + `${sum}`;
  } else {
    input = input.slice(0, 9) + `${11 - sum}`;
  }
  // const result = sum < 2 ? check === sum : check + sum === 11;
  // console.log({ input, result, newCheck: isValidIranianNationalCode(input) })
  return input;
};

export const toEnglishDigits = (str) => {
  try {
    const persianNumbers = ['۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '۰'];
    const arabicNumbers = ['١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩', '٠'];
    const englishNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

    return str
      .split('')
      .map(
        (c) =>
          englishNumbers[persianNumbers.indexOf(c)] ||
          englishNumbers[arabicNumbers.indexOf(c)] ||
          c
      )
      .join('');
  } catch (e) {
    return '0';
  }
};

export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export const checkRoles = (roles, userRoles) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const role of roles) {
    if (userRoles.includes(role)) return true;
  }
  return false;
};

export const getLocationString = async (_lat, _lng) => {
  try {
    if (_lat === undefined || _lng === undefined)
      throw new Error('empty customer');
    const response = await Axios.get(
      `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${_lat}&lon=${_lng}&accept-language=fa`
    );
    return response.data.display_name;
  } catch (err) {
    console.log(err);
    return `طول: ${_lng == null ? 'ثبت نشده' : _lng}   عرض: ${
      _lat == null ? 'ثبت نشده' : _lat
    }`;
  }
};

export const getPersianStatus = (status) => {
  if (status === 'building') return 'در حال ساخت';
  if (status === 'review') return 'در حال بررسی';
  return 'نهایی';
};

export const getColorStatus = (status) => {
  if (status === 'building') return '#3B5FED';
  if (status === 'review') return '#B643E6';
  return '#43E67C';
};

export const getColorRole = (role) => {
  switch (role) {
    case UserRole.Admin:
      return 'success';
    case UserRole.ManagerReporter:
    case UserRole.Manager:
      return 'primary';
    case UserRole.Storekeeper:
      return 'dark';
    case UserRole.Callcenter:
      return 'secondary';
    case UserRole.Advisor:
      return 'danger';
    default:
      return 'info';
  }
};

export const CustomToast = (message, title, type) => {
  NotificationManager[type](message, title, 3000, null, null, '');
};

export const encrypt = (str) => {
  try {
    // return CryptoJS.AES.encrypt(str, '1j4f0ss').toString();
    const words = CryptoJS.enc.Utf8.parse(str);
    return CryptoJS.enc.Base64.stringify(words);
  } catch (e) {
    return '';
  }
};

export const decrypt = (str) => {
  try {
    // return CryptoJS.AES.decrypt(str, '1j4f0ss').toString(CryptoJS.enc.Utf8);
    const words = CryptoJS.enc.Base64.parse(str);
    return CryptoJS.enc.Utf8.stringify(words);
  } catch (e) {
    return '';
  }
};

export const getActionStatusBadge = (action) => {
  switch (action.status) {
    case ActionStatusType.RUNNING:
      return (
        <Badge style={{ marginRight: 10 }} color="warning">
          در حال اجرا
        </Badge>
      );
    case ActionStatusType.SUCCESS:
      return (
        <Badge style={{ marginRight: 10 }} color="success">
          تکمیل شده
        </Badge>
      );
    case ActionStatusType.FAILED:
      return (
        <Badge style={{ marginRight: 10 }} color="danger">
          شکست عملیات
        </Badge>
      );
    case ActionStatusType.NOT_START:
      return (
        <Badge style={{ marginRight: 10 }} color="info">
          در صف اجرا
        </Badge>
      );
    default:
      return null;
  }
};

export const getTime = (val) => {
  const m = moment(val);
  return m.format('HH:mm'); // it would be in jalali system
};

export const getDate = (val, locale = 'fa') => {
  const m = moment(val);
  m.locale(locale);
  return m.format('YYYY/MM/DD'); // it would be in jalali system
};

export function errorHandler(error) {
  try {
    if ('response' in error) {
      const keys = Object.keys(error?.response?.data?.errors);
      if (keys.length > 0) {
        for (const item of keys)
          CustomToast(
            error?.response?.data?.errors[item][0],
            'خطای عملیات',
            'error'
          );
      } else {
        CustomToast(error?.response?.data?.message, 'خطای عملیات', 'error');
      }
    } else {
      CustomToast(error?.message, 'خطای عملیات', 'error');
    }
  } catch (e) {
    CustomToast(error?.message, 'خطا انجام فرآیند', 'error');
  }
}

export const convertedFeatures = (log, features) => {
  let temp = log?.features?.reduce((p, c, idx) => {
    const feature = features?.find((i) => i.id == c.feature_id);
    p.push({
      fid: c.feature_id,
      subfid: c.sub_feature_id,
      group_name: feature?.name,
      sub_group_name:
        feature?.sub?.find((i) => i.id == c.sub_feature_id)?.name ?? '-',
      count: c?.count ? getLocalNumber(c?.count) : '-',
      size:
        feature?.id == 1
          ? c?.size == 'half'
            ? 'نیم‌پرس'
            : c?.size == 'full'
            ? 'پرس'
            : undefined ?? '-'
          : '-',
      description: c?.description ?? '',
    });
    return p;
  }, []);

  temp.sort((a, b) => a?.fid - b?.fid);

  return temp;
};
